import UserStatusCheck from "../../utils/UserStatusCheck" // Adjust the path as needed

// This component will wrap routes that require an active/approved user
const ActiveUserRoute = ({ children }) => {
  return <UserStatusCheck>{children}</UserStatusCheck>
}

export default ActiveUserRoute

